{
  "name": "ohm-js",
  "version": "16.6.0",
  "description": "An object-oriented language for parsing and pattern matching",
  "repository": "https://github.com/harc/ohm",
  "keywords": [
    "parser",
    "compiler",
    "pattern matching",
    "pattern-matching",
    "ometa",
    "ometa/js",
    "ometa-js",
    "ometajs",
    "rapid",
    "prototyping"
  ],
  "homepage": "https://ohmjs.org",
  "bugs": "https://github.com/harc/ohm/issues",
  "main": "index.js",
  "module": "dist/ohm.esm.js",
  "files": [
    "src",
    "dist",
    "extras",
    "third_party",
    "index.d.ts"
  ],
  "types": "index.d.ts",
  "scripts": {
    "prebootstrap": "bash scripts/prebootstrap",
    "bootstrap": "bash scripts/bootstrap --test || (echo 'Bootstrap failed.' && mv -v dist/ohm-grammar.js.old dist/ohm-grammar.js && mv -v dist/built-in-rules.js.old dist/built-in-rules.js && mv -v dist/operations-and-attributes.js.old dist/operations-and-attributes.js)",
    "build": "yarn build-debug && webpack --mode=production",
    "build-debug": "webpack --mode=development && yarn build-esm && node scripts/generate-types.mjs",
    "build-esm": "rollup -c rollup.config.mjs",
    "clean": "rm -f dist/ohm.js dist/ohm.min.js",
    "lint": "eslint . --ignore-path ../.eslintignore",
    "format": "prettier . --write --ignore-path ../.prettierignore --config ../.prettierrc && eslint . --ignore-path ../.eslintignore --fix",
    "test": "ava && ava --config ava-ts.config.js test/test-typings.ts",
    "test-watch": "ava --watch",
    "pre-commit": "yarn run lint && yarn run build && yarn run test",
    "prepublishOnly": "bash scripts/prepublishOnly",
    "prepack": "cp ../../README.md . && yarn build",
    "postpack": "rm README.md",
    "postpublish": "echo '👉  Now go to https://github.com/harc/ohm/releases and create a release.'",
    "unsafe-bootstrap": "bash scripts/bootstrap",
    "update-contributors": "bash scripts/update-contributors",
    "watch": "webpack --mode=development --watch"
  },
  "license": "MIT",
  "author": "Alex Warth <alexwarth@gmail.com> (http://tinlizzie.org/~awarth)",
  "contributors": [
    "Patrick Dubroy <pdubroy@gmail.com>",
    "Meixian Li <lmeixian@gmail.com>",
    "Marko Röder <m.roeder@photon-software.de>",
    "Tony Garnock-Jones <tonygarnockjones@gmail.com>",
    "Saketh Kasibatla <sake.kasi@gmail.com>",
    "Lionel Landwerlin <llandwerlin@gmail.com>",
    "Jason Merrill <jwmerrill@gmail.com>",
    "Ray Toal <rtoal@lmu.edu>",
    "Yoshiki Ohshima <Yoshiki.Ohshima@acm.org>",
    "megabuz <3299889+megabuz@users.noreply.github.com>",
    "Jonathan Edwards <JonathanMEdwards@gmail.com>",
    "Milan Lajtoš <milan.lajtos@me.com>",
    "Neil Jewers <njjewers@uwaterloo.ca>",
    "stagas <gstagas@gmail.com>",
    "AngryPowman <angrypowman@qq.com>",
    "Arthur Carabott <arthurc@gmail.com>",
    "Casey Olson <casey.m.olson@gmail.com>",
    "Daniel Tomlinson <DanielTomlinson@me.com>",
    "Ian Harris <ian@fofgof.xyz>",
    "Justin Chase <justin.m.chase@gmail.com>",
    "Leslie Ying <acetophore@users.noreply.github.com>",
    "Luca Guzzon <luca.guzzon@gmail.com>",
    "Mike Niebling <(none)>",
    "Patrick Dubroy <patrick@sourcegraph.com>",
    "Pierre Donias <pierre.donias@gmail.com>",
    "Stan Rozenraukh <stan@stanistan.com>",
    "Stephan Seidt <stephan.seidt@gmail.com>",
    "Steve Phillips <steve@tryingtobeawesome.com>",
    "Szymon Kaliski <kaliskiszymon@gmail.com>",
    "Thomas Nyberg <tomnyberg@gmail.com>",
    "Vse Mozhet Byt <vsemozhetbyt@gmail.com>",
    "Wil Chung <10446+iamwilhelm@users.noreply.github.com>",
    "Zachary Sakowitz <zsakowitz@gmail.com>",
    "abego <ub@abego-software.de>",
    "acslk <d_vd415@hotmail.com>",
    "codeZeilen <codeZeilen@users.noreply.github.com>",
    "kassadin <kassadin@foxmail.com>",
    "owch <bowenrainyday@gmail.com>",
    "sfinnie <scott.finnie@gmail.com>"
  ],
  "dependencies": {},
  "devDependencies": {
    "@ohm-js/cli": "^1.0.0",
    "@rollup/plugin-commonjs": "^21.0.1",
    "@rollup/plugin-json": "^4.1.0",
    "@rollup/plugin-node-resolve": "^13.1.3",
    "ava": "^3.15.0",
    "ava-spec": "^1.1.1",
    "dedent": "^0.7.0",
    "eslint": "^7.9.0",
    "eslint-config-google": "^0.14.0",
    "eslint-plugin-ava": "^11.0.0",
    "eslint-plugin-camelcase-ohm": "^0.2.1",
    "eslint-plugin-no-extension-in-require": "^0.2.0",
    "husky": "^4.2.5",
    "jsdom": "^9.9.1",
    "json": "^9.0.6",
    "markscript": "^0.5.0",
    "node-static": "^0.7.11",
    "ohm-grammar-ecmascript": "^1.0.0",
    "rollup": "^2.63.0",
    "ts-loader": "^8.0.4",
    "ts-node": "^9.0.0",
    "typescript": "^4.0.3",
    "walk-sync": "^2.2.0",
    "webpack": "^4.44.2",
    "webpack-cli": "^3.3.12"
  },
  "engines": {
    "node": ">=0.12.1"
  }
}
